import { ICountry } from '@models/country.interface';
import { TranslateModule } from '@ngx-translate/core';
import { UiSelectItem } from '@services/util/select-item-loader.service';
import { SelectModule } from 'primeng/select';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { countries } from '../../../data/countries.data';

@Component({
  selector: 'app-country-select',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule, SelectModule],
  templateUrl: './country-select.component.html'
})
export class CountrySelectComponent implements OnInit {
  @Input() value?: string | null;
  @Input() placeholder = 'booking.detail.selectCountry';
  @Input() disabled = false;
  @Input() showClear = true;
  @Input() styleClass = 'w-full';
  @Output() valueChange = new EventEmitter<string | null>();
  @Output() onChange = new EventEmitter<any>();

  countries: UiSelectItem<ICountry>[] = [];
  loading = false;

  ngOnInit(): void {
    this.loadCountries();
  }

  /**
   * Load countries from the static data
   */
  private loadCountries(): void {
    this.loading = true;

    // Transform legacy UI select items to the format needed by the component
    this.countries = countries.map((country: ICountry) => ({
      value: country.code,
      explicitTitle: country.name,
      icon: country.options?.icon,
      model: country
    }));

    // Sort alphabetically
    this.countries.sort((a, b) => (a.explicitTitle || '').localeCompare(b.explicitTitle || ''));

    this.loading = false;
  }

  /**
   * Handle value change and emit events
   */
  handleValueChange(event: any): void {
    this.valueChange.emit(this.value);
    this.onChange.emit(event);
  }
}
